import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { createClientEvent, editClientEvent } from '../../../_events/clients/create_client.event';
import { findAllClientsByCompanyEvent } from '../../../_events/clients/find_clients.event';
import { message } from "antd";
import AutoSelectSellers from './auto_select_sellers';
import AutoSelectCity from './auto_select_city';
import { MAIN_ROUTES, APP_ROUTES } from '../../../_config/routes';
import DownloadSellerPrices from "./download_seller_prices";
import { ROLES } from "../../../_config/roles";
import RolWrapper from "../../hoc/roles_wrapper";
import { FormControlLabel, Switch } from "@mui/material";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin]);

const Clients = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'name', headerName: 'Nombre', width: 200 },
        { field: 'identification', headerName: 'NIT', width: 200 },
        { field: 'address', headerName: 'Dirección', width: 200 },
        { field: 'email_invoice', headerName: 'Correo Facturación', width: 200 },
        { field: 'seller', headerName: 'Vendedor', width: 200,
        valueGetter: (params) => params.row.seller?params.row.seller.full_name : '',
            renderCell: (params) => { 
                return <span>{params.row.seller?params.row.seller.full_name : ''}</span>;
            }
        },
        { field: 'uuid', headerName: 'Acciones', width: 300, sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem(params.row); setRender('form');
                };    
                return(
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <Link style={{ margin: '0 10px' }} to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.prices}/?c=${params.row.uuid}`}>
                            <Button variant="contained">Precios</Button>
                        </Link>
                        <Link style={{ marginRight: '10px' }} to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.ean}/?c=${params.row.uuid}&cod=${params.row.cod}`}>
                            <Button variant="contained">EAN</Button>
                        </Link>
                        <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>                        
                    </div>
                );
            }
        },
    ];

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Clientes
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'100%'}}>
                        {
                            render === 'info' ? 
                            <ButtonRolAuthComponent onClick={() => {setItem(null);setRender('form');}} variant="contained">Crear nuevo</ButtonRolAuthComponent>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <span style={{marginRight: '10px'}}>Exportar:</span>
                    <DownloadSellerPrices />
                </div>
                <hr />
                {
                    render === 'info' ? <ClientInfo columns={columns} /> : <ClientForm item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const ClientInfo = (props) => {

    const [clients, setClients] = useState([]);

    const findClients = () => {
        findAllClientsByCompanyEvent()
        .then(data => {
            setClients(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findClients();
    }, []);   

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={clients}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

const ClientForm = (props) => {
    let { item } = props; 

    const createClient = () => {
        createClientEvent()
        .then(data => {
            message.success('Creado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const editClient = () => {
        if(item){
            editClientEvent(item.uuid)
            .then(data => {
                message.success('Editado');
            })
            .catch(err => {
                message.error(err.message);
            });
        } else {
            message.error('Entity not detected');
        }
        
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={8}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_name" 
                        label="Razón social" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.name : null}
                    />        
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControlLabel
                        control={
                            <Switch defaultChecked={ item?.special === 1 } id="ean" />
                        }
                        label={ "Activar EAN" }
                    />     
                </Grid>
                <Grid item xs={6} md={6}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_identification" 
                        label="NIT" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.identification : null}
                    />        
                </Grid>
                <Grid item xs={6} md={6}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_cod" 
                        label="Código" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.cod : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_address" 
                        label="Dirección" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.address : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_email_market" 
                        label="Correo comercial" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.email_market : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_email_account" 
                        label="Correo contabilidad" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.email_account : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="client_email_invoice" 
                        label="Correo facturación" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.email_invoice : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <AutoSelectSellers 
                        seller = {item ? item.seller : null}
                    />    
                </Grid>     
                <Grid item xs={12} md={12}>
                    <AutoSelectCity 
                        city = {item ? item.city : null}
                    />    
                </Grid>           
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editClient()} variant="contained">Editar</Button>
                        : <Button style={{width: '100%'}} onClick={() => createClient()} variant="contained">Guardar</Button>
                    }      
                </Grid>                
            </Grid>
        </div>
    );
}

export default Clients;